import { Link } from 'react-router-dom';

/**
 * Footer component with contact info and legal links
 */
function Footer() {
	const currentYear = new Date().getFullYear();

	return (
		<footer className="footer">
			<div className="footer-container">
				<div className="footer-main">
					<div className="footer-brand">
						<img 
							src={process.env.PUBLIC_URL + '/logo.png'} 
							alt="3oh logo" 
							className="footer-logo"
						/>
						<p className="footer-tagline">Building the decentralized future</p>
					</div>
					<div className="footer-contact">
						<h4>Contact</h4>
						<a href="mailto:hello@3oh.io" className="footer-link">hello@3oh.io</a>
				
					</div>
				</div>
				<div className="footer-bottom">
					<p className="footer-copyright">
						&copy; {currentYear} 3oh Inc. All rights reserved.
					</p>
					<div className="footer-legal">
						<Link to="/terms-of-service" className="footer-link">Terms of Service</Link>
						<Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
